// MARK://dhk8/admin-shell/lib/queries/inventory
// Queries tipadas de inventario — F2.1 / ADR-0009. El Admin lee stock items y
// almacenes por el grafo (erp-inventory), tenant del JWT (RLS). El nombre del
// producto se resuelve por la federación (StockItem.product → erp-products) para
// no mostrar UUIDs cuando el sku es null. Escrituras siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminStockItemsQuery = graphql(`
  query AdminStockItems($limit: Int) {
    stockItems(limit: $limit) {
      items {
        id
        productId
        ingredientName
        sku
        qty
        reservedQty
        uom
        reorderPoint
        unitCostCents
        warehouseId
        product {
          name
        }
      }
    }
  }
`)

// B / decisión Gustavo 2026-06-22: presentaciones de compra de un insumo
// (erp-inventory). Garrafón = 20000 MLT, etc. Lectura por el grafo (tenant del JWT).
export const AdminPackPresentationsQuery = graphql(`
  query AdminPackPresentations($productId: ID!) {
    packPresentations(productId: $productId) {
      id
      productId
      name
      purchaseUnit
      factor
      baseUnit
      active
    }
  }
`)

export const AdminWarehousesQuery = graphql(`
  query AdminWarehouses {
    warehouses {
      id
      name
      code
      active
    }
  }
`)


// ── F6.2 R3b: historial de movimientos + lotes FEFO por el grafo (erp-inventory,
// tenant del JWT, RLS). Reemplazan los GET REST /v1/erp/stock-movements y /v1/erp/lots.
export const AdminStockMovementsQuery = graphql(`
  query AdminStockMovements($limit: Int) {
    stockMovements(limit: $limit) {
      items {
        id
        type
        stockItemId
        lotId
        qty
        srcWarehouseId
        dstWarehouseId
        ref
        refType
        reason
        reversed
        createdAt
      }
    }
  }
`)

export const AdminStockLotsQuery = graphql(`
  query AdminStockLots($limit: Int) {
    stockLots(limit: $limit) {
      items {
        id
        stockItemId
        lotNumber
        serialNumber
        expiryDate
        mfgDate
        qty
        consumedQty
        sku
        uom
        warehouseId
        createdAt
      }
    }
  }
`)


// ── F8.x: escrituras de inventario por el grafo (erp-inventory, tenant del JWT, RLS) ──
export const AdminCreateWarehouseMutation = graphql(`
  mutation AdminCreateWarehouse($input: ErpWarehouseCreateInput!) {
    createWarehouse(input: $input) {
      id
      name
      code
      active
    }
  }
`)

export const AdminUpdateWarehouseMutation = graphql(`
  mutation AdminUpdateWarehouse($id: ID!, $input: ErpWarehouseUpdateInput!) {
    updateWarehouse(id: $id, input: $input) {
      id
      name
      code
      active
    }
  }
`)

export const AdminDeleteWarehouseMutation = graphql(`
  mutation AdminDeleteWarehouse($id: ID!) {
    deleteWarehouse(id: $id)
  }
`)

export const AdminCreateStockItemMutation = graphql(`
  mutation AdminCreateStockItem($input: ErpStockItemCreateInput!) {
    createStockItem(input: $input) {
      id
      productId
      ingredientName
      sku
      qty
      reservedQty
      uom
      reorderPoint
      unitCostCents
    }
  }
`)

export const AdminUpdateStockItemMutation = graphql(`
  mutation AdminUpdateStockItem($id: ID!, $input: ErpStockItemUpdateInput!) {
    updateStockItem(id: $id, input: $input) {
      id
      productId
      ingredientName
      sku
      qty
      reservedQty
      uom
      reorderPoint
      unitCostCents
    }
  }
`)

// B: alta/edición + borrado de presentaciones de compra por el grafo (erp-inventory).
export const AdminUpsertPackPresentationMutation = graphql(`
  mutation AdminUpsertPackPresentation($input: ErpPackPresentationInput!) {
    upsertPackPresentation(input: $input) {
      id
      productId
      name
      purchaseUnit
      factor
      baseUnit
      active
    }
  }
`)

export const AdminDeletePackPresentationMutation = graphql(`
  mutation AdminDeletePackPresentation($id: ID!) {
    deletePackPresentation(id: $id)
  }
`)

export const AdminDeleteStockItemMutation = graphql(`
  mutation AdminDeleteStockItem($id: ID!) {
    deleteStockItem(id: $id)
  }
`)

export const AdminAdjustStockMutation = graphql(`
  mutation AdminAdjustStock($stockItemId: ID!, $qty: Float!, $reason: String) {
    adjustStock(stockItemId: $stockItemId, qty: $qty, reason: $reason) {
      id
      productId
      sku
      qty
      reservedQty
      uom
      reorderPoint
    }
  }
`)
